module.exports = __webpack_public_path__ + "static/media/CT_2019_30457A_pdf.f826e233.pdf";